import { HttpClient } from '@adapters/HttpClient';
import { IntegrationTokenResponse, IntegrationsResponse } from '../models/Integrations';

export class IntegrationsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getIntegrations(): Promise<IntegrationsResponse> {
    return this.httpClient.get<IntegrationsResponse>('/integrations');
  }

  async getChatbyToken(): Promise<IntegrationTokenResponse> {
    return this.httpClient.get<IntegrationTokenResponse>('/integrations/chatby/token');
  }
}
